import r from "./index444.mjs";
import a from "./index445.mjs";
import { handleBreakpoints as p, values as d } from "./index447.mjs";
function i(t) {
  return t <= 1 && t !== 0 ? `${t * 100}%` : t;
}
const f = r({
  prop: "width",
  transform: i
}), s = (t) => {
  if (t.maxWidth !== void 0 && t.maxWidth !== null) {
    const h = (e) => {
      var n, o;
      const m = ((n = t.theme) == null || (n = n.breakpoints) == null || (n = n.values) == null ? void 0 : n[e]) || d[e];
      return m ? ((o = t.theme) == null || (o = o.breakpoints) == null ? void 0 : o.unit) !== "px" ? {
        maxWidth: `${m}${t.theme.breakpoints.unit}`
      } : {
        maxWidth: m
      } : {
        maxWidth: i(e)
      };
    };
    return p(t, t.maxWidth, h);
  }
  return null;
};
s.filterProps = ["maxWidth"];
const l = r({
  prop: "minWidth",
  transform: i
}), u = r({
  prop: "height",
  transform: i
}), x = r({
  prop: "maxHeight",
  transform: i
}), c = r({
  prop: "minHeight",
  transform: i
});
r({
  prop: "size",
  cssProperty: "width",
  transform: i
});
r({
  prop: "size",
  cssProperty: "height",
  transform: i
});
const g = r({
  prop: "boxSizing"
});
a(f, s, l, u, x, c, g);
export {
  g as boxSizing,
  u as height,
  x as maxHeight,
  s as maxWidth,
  c as minHeight,
  l as minWidth,
  i as sizingTransform,
  f as width
};
